import React , {Component} from "react"
import Asset4 from "../../assets/Client/04.png"
import GoogleMapReact from 'google-map-react';
import { Col, Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import './styles.css'


import Support from '../../assets/ContactUs/Rectangle 41.svg'
import {Helmet} from "react-helmet";
import FavIcon from "../../assets/FavIcons/04.ico";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export class Contact extends Component{
    constructor(props) {
        super(props);
    }
    // componentDidMount () {
    //     const script = document.createElement("script");
    //     script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDdJdhzDdv0uNKZM8A0yLRpw4M_DLF2CAo&callback=initMap&libraries=&v=weekly";
    //     script.async = true;
    //     document.body.appendChild(script);
    //     setTimeout(()=>{
    //             // The location of Uluru
    //             const uluru = { lat: -25.344, lng: 131.036 };
    //             // The map, centered at Uluru
    //             const map = new google.maps.Map(document.getElementById("map"), {
    //                 zoom: 4,
    //                 center: uluru,
    //             });
    //             // The marker, positioned at Uluru
    //             const marker = new google.maps.Marker({
    //                 position: uluru,
    //                 map: map,
    //             });
    //     },1000);
    //
    // }
    // initMap() {
    //     // The location of Uluru
    //     const uluru = { lat: -25.344, lng: 131.036 };
    //     // The map, centered at Uluru
    //     const map = new google.maps.Map(document.getElementById("map"), {
    //         zoom: 4,
    //         center: uluru,
    //     });
    //     // The marker, positioned at Uluru
    //     const marker = new google.maps.Marker({
    //         position: uluru,
    //         map: map,
    //     });
    // }
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title> ADSIL Nous Contacter</title>
                    <link rel="shortcut icon"  href={FavIcon} />
                </Helmet>
                <div className="col-12 text-black"  id="contactUsSec1" style={{paddingTop : '2rem'}}>
                    <div className="d-flex justify-content-center mt-4 mb-4">
                        <img style={{height : '5rem'}} src={Asset4} alt=""/>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <h2 className="pt-1 d-inline" style={{textAlign : 'center' , borderBottom : "5px solid var(--primary-adsil-color)" , fontWeight : 'bold'}}> NOUS CONTACTER </h2>
                    </div>
                    <div className="d-lg-flex formContainer mt-lg-4 mb-lg-4">
                        <div className="col-lg-5 col-12 p-4 p-lg-5 mt-4 mb-4 mt-lg-0" style={{border: '1px solid #707070' ,  borderRadius: '10px' , textAlign : 'center'}}>
                            <h1  style={{fontWeight : 'bold'}} className="pt-2 pb-2"> Ecrivez-nous </h1>
                            <Form>
                                <div  className="row formRaw">
                                    <div className="col-6">
                                        <Input type="text" name="prenom"  placeholder="Prénom" />
                                    </div>
                                    <div className="col-6">
                                        <Input type="text" name="nom"  placeholder="Nom" />
                                    </div>
                                </div>
                                <div  className="row formRaw">
                                    <div className="col-12">
                                        <Input type="email" name="email" placeholder="Adresse Email"/>
                                    </div>
                                </div>
                                <div className="row formRaw">
                                    <div className="col-12">
                                        <Input rows={6} type="textarea" name="text" id="exampleText" placeholder="Votre message ici ..." />
                                    </div>
                                </div>
                                <div className="d-lg-flex justify-content-center">
                                    <Button className="col-lg-5 pt-lg-3 pb-lg-3" id="formButton"> Envoyer </Button>
                                </div>
                            </Form>
                        </div>
                        <div className="col-lg-5 col-12 mt-4 mb-4 mt-lg-0" id="mapContainer" >
                            <GoogleMapReact
                                bootstrapURLKeys={{ key: 'AIzaSyDdJdhzDdv0uNKZM8A0yLRpw4M_DLF2CAo'}}
                                defaultCenter={[36.7354892, 3.1783048]}
                                defaultZoom={15}
                                yesIWantToUseGoogleMapApiInternals
                            >
                                <AnyReactComponent
                                    lat={36.7354892}
                                    lng={3.1783048}
                                    text="ADSIL"
                                />
                            </GoogleMapReact>
                        </div>
                    </div>
                </div>
            </React.Fragment>

        )
    }
}